import {
  INVALID_UUID_ERROR_MESSAGE,
  INVALID_UUID_STATUS,
  NOT_FOUND_STATUS,
} from '@/services/types/errors/mockNotFoundError'
import { type AppError } from '../../classes/AppError'

export function isNotFoundError(error: AppError): boolean {
  const hasNotFoundStatus = error.status === NOT_FOUND_STATUS
  if (hasNotFoundStatus) return true

  const hasInvalidIdDeprecatedError =
    error.status === INVALID_UUID_STATUS && error.message === INVALID_UUID_ERROR_MESSAGE
  if (hasInvalidIdDeprecatedError) return true

  const hasInvalidIdCustomError =
    error.status === INVALID_UUID_STATUS &&
    error.errors?.some(
      ({ code, description }) =>
        code === 'invalid_string' && description === '[path] - Invalid uuid',
    )
  if (hasInvalidIdCustomError) return true

  return false
}
